function getDefSites() {
    const sitesData = require('../../assets/defSites.json');
    const sitesObj = {};
    const siteList = [];

    sitesData.forEach(data => {
        const site = {};
        const siteAttributes = {};

        siteAttributes["DefSiteId"] = data.id;
        siteAttributes["Mode"] = 0;
        siteAttributes["Tpl"] = data.name;
        siteAttributes["Incl"] = "";

        site["@"] = siteAttributes;

        siteList.push(site);
    });

    sitesObj["Site"] = siteList;
    return sitesObj;
}

export default getDefSites;